export const SET_TAP_BAR_DATA = 'SAVE_TAP_BAR_DATA';
